import { api } from '../../api.empty';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateServiceLevelDefinition: build.mutation<
      UpdateServiceLevelDefinitionApiResponse,
      UpdateServiceLevelDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/${queryArg.recId}`,
        method: 'PUT',
        body: queryArg.updateServiceLevelDefinitionRequestBody,
      }),
    }),
    getServiceLevelDefinitionById: build.query<
      GetServiceLevelDefinitionByIdApiResponse,
      GetServiceLevelDefinitionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/${queryArg.recId}`,
      }),
    }),
    deleteServiceLevelDefinition: build.mutation<
      DeleteServiceLevelDefinitionApiResponse,
      DeleteServiceLevelDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/${queryArg.recId}`,
        method: 'DELETE',
      }),
    }),
    updateServiceLevelDefinitionNsbSetups: build.mutation<
      UpdateServiceLevelDefinitionNsbSetupsApiResponse,
      UpdateServiceLevelDefinitionNsbSetupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/nsbsetup/${queryArg.serviceLevelDefinition}`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    listServiceLevelDefinitionNsbSetups: build.query<
      ListServiceLevelDefinitionNsbSetupsApiResponse,
      ListServiceLevelDefinitionNsbSetupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/nsbsetup/availablensbs/${queryArg.serviceLevelDefinitionId}`,
      }),
    }),
    listServiceLevelDefinitionNsbs: build.query<
      ListServiceLevelDefinitionNsbsApiResponse,
      ListServiceLevelDefinitionNsbsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/nsbsetup/nsbs/${queryArg.serviceLevelDefinitionId}`,
      }),
    }),
    deleteServiceLevelDefinitionNsbSetup: build.mutation<
      DeleteServiceLevelDefinitionNsbSetupApiResponse,
      DeleteServiceLevelDefinitionNsbSetupApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition/nsbsetup/${queryArg.recId}`,
        method: 'DELETE',
      }),
    }),
    listServiceLevelDefinitions: build.query<
      ListServiceLevelDefinitionsApiResponse,
      ListServiceLevelDefinitionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition`,
        params: {
          showDeleted: queryArg.showDeleted,
        },
      }),
    }),
    createServiceLevelDefinition: build.mutation<
      CreateServiceLevelDefinitionApiResponse,
      CreateServiceLevelDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/ServiceLevelDefinition`,
        method: 'POST',
        body: queryArg.createServiceLevelDefinitionRequest,
      }),
    }),
    listServiceLevelDefinitionClassifiers: build.query<
      ListServiceLevelDefinitionClassifiersApiResponse,
      ListServiceLevelDefinitionClassifiersApiArg
    >({
      query: () => ({ url: `/api/service-level-classifiers` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as serviceLevelDefinitionsApi };
export type UpdateServiceLevelDefinitionApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionDto;
export type UpdateServiceLevelDefinitionApiArg = {
  recId: number;
  updateServiceLevelDefinitionRequestBody: UpdateServiceLevelDefinitionRequestBody;
};
export type GetServiceLevelDefinitionByIdApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionDto;
export type GetServiceLevelDefinitionByIdApiArg = {
  recId: number;
};
export type DeleteServiceLevelDefinitionApiResponse =
  /** status 200 Success */ boolean;
export type DeleteServiceLevelDefinitionApiArg = {
  recId: number;
};
export type UpdateServiceLevelDefinitionNsbSetupsApiResponse =
  /** status 200 Success */ boolean;
export type UpdateServiceLevelDefinitionNsbSetupsApiArg = {
  serviceLevelDefinition: number;
  body: ServiceLevelDefinitionNsbSetupModel[];
};
export type ListServiceLevelDefinitionNsbSetupsApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionNsbSetupDto[];
export type ListServiceLevelDefinitionNsbSetupsApiArg = {
  serviceLevelDefinitionId: number;
};
export type ListServiceLevelDefinitionNsbsApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionNsbDto[];
export type ListServiceLevelDefinitionNsbsApiArg = {
  serviceLevelDefinitionId: number;
};
export type DeleteServiceLevelDefinitionNsbSetupApiResponse =
  /** status 200 Success */ boolean;
export type DeleteServiceLevelDefinitionNsbSetupApiArg = {
  recId: number;
};
export type ListServiceLevelDefinitionsApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionDto[];
export type ListServiceLevelDefinitionsApiArg = {
  showDeleted?: boolean | null;
};
export type CreateServiceLevelDefinitionApiResponse =
  /** status 200 Success */ ServiceLevelDefinitionDto;
export type CreateServiceLevelDefinitionApiArg = {
  createServiceLevelDefinitionRequest: CreateServiceLevelDefinitionRequest;
};
export type ListServiceLevelDefinitionClassifiersApiResponse =
  /** status 200 Success */ ClassifierDtos;
export type ListServiceLevelDefinitionClassifiersApiArg = void;
export type ServiceLevelDefinitionDto = {
  recId: number;
  serviceLevelName: string;
  documentServices: number;
  languages: number;
  draftStandards: number;
  redline: number;
  previousVersions: number;
  multiLanguage: boolean;
  priceFactor?: number | null;
  subscriptionLicenseType?: number | null;
  deleted: boolean;
  createdDateTime: string;
  createdBy: string;
  modifiedDateTime: string;
  dataId: string;
  modifiedBy: string;
  allowedNsbIds: string[];
};
export type SpError = {
  message?: string | null;
};
export type SpProblemDetails = {
  title?: string | null;
  status: number;
  detail?: string | null;
  instance?: string | null;
  traceId?: string | null;
  errors?: SpError[] | null;
};
export type UpdateServiceLevelDefinitionRequestBody = {
  serviceLevelName: string;
  documentServices: DocumentService;
  languages: DocumentLanguage;
  draftStandards: NoYesEnum;
  redline: NoYesEnum;
  previousVersions: PreviousVersion;
  multiLanguage: boolean;
  priceFactor?: number | null;
  subscriptionLicenseType?: AgreementLicenseType | null;
  updateExistingSubscriptions: boolean;
};
export type ServiceLevelDefinitionNsbSetupModel = {
  recId: number;
  serviceLevelDefinitionRefId: number;
  nsbId: string;
};
export type ServiceLevelDefinitionNsbSetupDto = {
  recId: number;
  serviceLevelDefinitionRefId: number;
  nsbId: string;
  createdDateTime: string;
  createdBy: string;
  modifiedDateTime: string;
  dataId: string;
  modifiedBy: string;
};
export type ServiceLevelDefinitionNsbDto = {
  recId: number;
  nsbId: string;
  name: string;
  publisherId: string;
  canSell: number;
  calculationMethod: CalculationMethod;
  royaltyPercent: number;
  multiUserRoyaltyPercent: number;
  priceOnRequest: boolean;
  priceFactor: number;
  availableLanguages: number;
  availableDocumentServices: number;
};
export type CreateServiceLevelDefinitionRequest = {
  serviceLevelName: string;
  documentServices: DocumentService;
  languages: DocumentLanguage;
  draftStandards: NoYesEnum;
  redline: NoYesEnum;
  previousVersions: PreviousVersion;
  multiLanguage: boolean;
  allowedNsbIds: string[];
  priceFactor?: number | null;
  subscriptionLicenseType?: AgreementLicenseType | null;
};
export type DocumentServiceDto = {
  enumValue: number;
  name: string;
};
export type DocumentLanguageDto = {
  enumValue: number;
  name: string;
};
export type DraftStandardDto = {
  enumValue: number;
  name: string;
};
export type RedlineDto = {
  enumValue: number;
  name: string;
};
export type PreviousVersionDto = {
  enumValue: number;
  name: string;
};
export type SubscriptionLicenseTypeDto = {
  enumValue: number;
  name: string;
};
export type NsbDto2 = {
  id: number;
  nsbId: string;
};
export type ClassifierDtos = {
  documentServices: DocumentServiceDto[];
  languages: DocumentLanguageDto[];
  draftStandards: DraftStandardDto[];
  redline: RedlineDto[];
  previousVersions: PreviousVersionDto[];
  subscriptionLicenseTypes: SubscriptionLicenseTypeDto[];
  nsbs: NsbDto2[];
};
export enum DocumentService {
  None = 'None',
  Online = 'Online',
  Download = 'Download',
  Print = 'Print',
  HardCopy = 'HardCopy',
  OnlineReader = 'OnlineReader',
  Eform = 'Eform',
  Book = 'Book',
  EnhancedSoftware = 'EnhancedSoftware',
  EnhancedCopyPaste = 'EnhancedCopyPaste',
  MultipleUserCopy = 'MultipleUserCopy',
  Commenting = 'Commenting',
  AiAssistant = 'AIAssistant',
}
export enum DocumentLanguage {
  None = 'None',
  English = 'English',
  Norwegian = 'Norwegian',
  Spanish = 'Spanish',
  French = 'French',
  German = 'German',
  Italian = 'Italian',
  Danish = 'Danish',
  Russian = 'Russian',
  Swedish = 'Swedish',
  Portugese = 'Portugese',
  Arabic = 'Arabic',
  Finnish = 'Finnish',
  Chinese = 'Chinese',
  Estonian = 'Estonian',
}
export enum NoYesEnum {
  No = 'No',
  Yes = 'Yes',
}
export enum PreviousVersion {
  No = 'No',
  FromSubscriptionDate = 'FromSubscriptionDate',
  AllVersions = 'AllVersions',
}
export enum AgreementLicenseType {
  StandardLicense = 'StandardLicense',
  MultiUserLicense = 'MultiUserLicense',
  ServiceLicense = 'ServiceLicense',
  CustomSubscriptionLicense = 'CustomSubscriptionLicense',
}
export enum CalculationMethod {
  VariantBased = 'VariantBased',
  FactorBased = 'FactorBased',
}
export const {
  useUpdateServiceLevelDefinitionMutation,
  useGetServiceLevelDefinitionByIdQuery,
  useLazyGetServiceLevelDefinitionByIdQuery,
  useDeleteServiceLevelDefinitionMutation,
  useUpdateServiceLevelDefinitionNsbSetupsMutation,
  useListServiceLevelDefinitionNsbSetupsQuery,
  useLazyListServiceLevelDefinitionNsbSetupsQuery,
  useListServiceLevelDefinitionNsbsQuery,
  useLazyListServiceLevelDefinitionNsbsQuery,
  useDeleteServiceLevelDefinitionNsbSetupMutation,
  useListServiceLevelDefinitionsQuery,
  useLazyListServiceLevelDefinitionsQuery,
  useCreateServiceLevelDefinitionMutation,
  useListServiceLevelDefinitionClassifiersQuery,
  useLazyListServiceLevelDefinitionClassifiersQuery,
} = injectedRtkApi;
